import React, { useState } from 'react';
import { Hero } from './components/Hero';
import { Navbar } from './components/Navbar';
import { SignupModal } from './components/SignupModal';
import { ProblemSolution } from './components/ProblemSolution';
import { Solution } from './components/Solution';
import { Features } from './components/Features';
import { Interface } from './components/Interface';
import { Philosophy } from './components/Philosophy';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  return <div className="relative w-full min-h-screen bg-white text-charcoal-500 transition-colors duration-500" data-id="element-0">
      <Navbar openModal={openModal} data-id="element-1" />
      <Hero openModal={openModal} data-id="element-2" />
      <ProblemSolution data-id="element-3" />
      <Solution data-id="element-4" />
      <Features data-id="element-5" />
      <Interface data-id="element-6" />
      <Philosophy data-id="element-7" />
      <FinalCTA openModal={openModal} data-id="element-8" />
      <Footer data-id="element-9" />
      <SignupModal isOpen={isModalOpen} onClose={closeModal} data-id="element-10" />
    </div>;
}